import React, { useContext, useEffect, useState, useCallback } from 'react';
import { ThemeContext } from '../../context/ThemeContext';
import { NetworkContext } from '../../context/NetworkContext';
import { SetupContext } from '../../context/SetupContext';

import CustomText from '../../styles/CustomText';

import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { checkHeaderText } from '../../store';

import useSecureStorage from '../../hooks/useSecureStorage';
import useQssMnemonic from '../../hooks/useQssMnemonic';
import useQwalletServer from '../../hooks/useQwalletServer';
import { getTelegramId } from '../../utils/telegramClientData';

import WebApp from '@twa-dev/sdk'

import i18next from 'i18next'
import { tgShowConfirm, tgShowAlert } from '../../utils/telegramPopup';

import { Link, ExternalLink } from 'lucide-react';
import CustomSwtich from '../Componentization/Switch/CustomSwtich';

const SeeMoreScreen = () => {
	const { theme, toggleTheme } = useContext(ThemeContext)
	let navigate = useNavigate();
	let dispatch = useDispatch();
	const { t } = useTranslation();

	const { stopRequestTxData, stopDbSyncTimer } = useContext(NetworkContext)
	const { getIsUseQss, setIsUseQss, getLocalMnemonicHash, getBlockChain, getWalletAddress } = useSecureStorage()
	const { checkEmptyQssMnemonic, checkOverlapQssMnemonicHash } = useQssMnemonic()
	const { resetServerTxHistory } = useQwalletServer()

	const [isQssEnabled, setIsQssEnabled] = useState(false)
	const [usingQssMnemonic, setUsingQssMnemonic] = useState(true)
	const [IsSavedQssMnemonic, setIsSavedQssMnemonic] = useState(false)
	const [isDarkMode, setIsDarkMode] = useState(false)
	const setupContext = useContext(SetupContext);

	useEffect(() => {
		dispatch(checkHeaderText({ "link": "SeeMoreScreen", "title": t('stack_header_message_05') }))
	}, [])

	useEffect(() => {
		const fetchQssStatus = async () => {
			const useQss = await getIsUseQss()
			setIsQssEnabled(useQss)
		}
		fetchQssStatus()

		const value = localStorage.getItem('theme')
		if (value !== 'dark') {
			setIsDarkMode(false)
		} else {
			setIsDarkMode(true)
		}

	}, [])

	useEffect(() => {
		const checkQssUseStatus = async () => {
			// 지갑 생성/복구 시 현재 니모닉이 QSS에 저장된 상태인지 확인
			// const savedQssMnemonic = await getIsSavedQssMnemonic()
			// setIsSavedQssMnemonic(savedQssMnemonic)

			// 현재 선택된 네트워크
			const selNetwork = await getBlockChain()

			// QSS 니모닉 저장 사용 상태 확인
			const emptyQssMnemonic = await checkEmptyQssMnemonic(selNetwork)
			if(true === emptyQssMnemonic) {
				// QSS 니모닉저장 서비스 사용안함
				// QSS에 저장된 니모닉 데이터가 없음
				setIsSavedQssMnemonic(false)
				console.log(`QSS에 저장된 니모닉 정보 없음`)
			} else {
				// QSS 니모닉저장 서비스를 사용 중
				// QSS에 저장된 니모닉 데이터가 있음
				setIsSavedQssMnemonic(true)
				console.log(`QSS에 저장된 니모닉 정보 있음`)
			}

			// 현재 지갑에 설정된 니모닉 해시가 QSS에 저장되어 있는지 확인
			const localHash = await getLocalMnemonicHash()
			// console.log(`QssSettingMnemonicScreen localHash ${localHash}`)

			const checkQssOverlapHash = await checkOverlapQssMnemonicHash(localHash, selNetwork)
			// console.log(`QssSettingMnemonicScreen checkQssMnemonicHash ${checkQssOverlapHash}`)

			if(true === checkQssOverlapHash) {
				// QSS 니모닉저장 서비스 사용안함
				// QSS에 저장된 니모닉 데이터가 없음
				setUsingQssMnemonic(true)
				console.log(`QSS에 저장된 니모닉해시 정보 있음`)
			} else {
				// QSS 니모닉저장 서비스를 사용 중
				// QSS에 저장된 니모닉 데이터가 있음
				setUsingQssMnemonic(false)
				console.log(`QSS에 저장된 니모닉해시 정보 없음`)
			}
		}

		checkQssUseStatus()
	}, [])

	const items =
		// useMemo(
		// 	() => 
		[
			{
				icon: 'document-outline',
				text: i18next.t('see_more_screen_message_17'),
				screen: 'QssSettingMnemonicScreen',
				hasBadge: false,
				isToggle: false,
			},
			{
				icon: 'document-outline',
				text: i18next.t('see_more_screen_message_18'),
				screen: 'QssSettingWalletAddressScreen',
				hasBadge: false,
				isToggle: false,
			},
			{
				icon: 'lock-closed-outline',
				text: i18next.t('see_more_screen_message_02'),
				screen: 'SecuritySettings',
				hasBadge: false,
				isToggle: false
			},
			// { 
			// 	icon: 'headset-outline', 
			// 	text: i18next.t('see_more_screen_message_03'), 
			// 	screen: 'ContactUs', 
			// 	hasBadge: true 
			// },
			{
				icon: 'language-outline',
				text: i18next.t('see_more_screen_message_04'),
				screen: 'LanguageSettingsScreen',
				hasBadge: false,
				isToggle: false
			},
			{
				icon: 'moon-outline',
				text: i18next.t('see_more_screen_message_09'),
				screen: 'DarkMode',
				hasBadge: false,
				isToggle: true
			},
			{
				icon: 'reset-outline',
				text: i18next.t('see_more_screen_message_22'),
				screen: 'ResetTxHistory',
				hasBadge: false,
				isToggle: false
			},
			{
				icon: 'document-text-outline',
				text: i18next.t('see_more_screen_message_05'),
				screen: 'Terms',
				hasBadge: true,
				isToggle: false
			},
			{
				icon: 'document-outline',
				text: i18next.t('see_more_screen_message_06'),
				screen: 'PrivacyPolicy',
				hasBadge: true,
				isToggle: false
			},
			{
				icon: 'information-circle-outline',
				text: i18next.t('see_more_screen_message_07'),
				screen: 'VersionInfo',
				hasBadge: false,
				isToggle: false,
				version: process.env.REACT_APP_VERSION
			},
			{
				icon: 'token-outline',
				text: i18next.t('see_more_screen_message_13'),
				screen: 'TokenList',
				hasBadge: false,
				isToggle: false
			},
			// {
			// 	icon: 'token-outline',
			// 	text: i18next.t('see_more_screen_message_14'),
			// 	screen: 'TokenCreate',
			// 	hasBadge: false,
			// 	isToggle: false
			// },
		]
	// [appVersion, forceUpdate]
	// )
	
	// 환경설정 메뉴
	const handleEnvItemPress = async (screen: string) => {
		console.log(`handleEnvItemPress : ${screen}`)
		if (screen === 'QssSettingMnemonicScreen') {
			navigate(`/${screen}`)
		} else if (screen === 'QssSettingAddressScreen') {
			// WebApp.showPopup({message: "준비중 입니다"})
			// navigate(`/${screen}`, { replace: true, state: {} });
			navigate(`/${screen}`)
		} else {
			// @ts-ignore
			navigate(`/${screen}`)
		}
	}

	const handleItemPress = useCallback(
		async (screen: string, hasBadge: boolean) => {
			if (screen === 'Terms' && hasBadge) {
				let url = setupContext.commonInfo?.term_url || ''
				try {
					window.open(url, '_blank');
				} catch (error) {
					console.log('Failed to open Terms URL: ', error)
				}
			} else if (screen === 'PrivacyPolicy' && hasBadge) {
				let url = setupContext.commonInfo?.privacy_url || ''
				console.log(`PrivacyPolicy : ${url}`);
				try {
					window.open(url, '_blank');
				} catch (error) {
					console.error('Failed to open PrivacyPolicy URL: ', error)
				}
			} else if (screen !== 'Terms' && screen !== 'PrivacyPolicy' && hasBadge) {
				let url = setupContext.commonInfo?.prepare_url || ''
				try {
					window.open(url, '_blank');
				} catch (error) {
					console.error('Failed to open Prepare URL: ', error)
				}
			} else if (screen === 'VersionInfo') {
				handleShare()
			} else if (screen === 'ResetTxHistory') {
				handleResetTxHistory()
			} else {
				// @ts-ignore
				navigate(`/${screen}`)
			}
		},
		[navigate]
	)

	const handleToggleSwitch = async () => {
		
		try {
			if(false === isQssEnabled) {
				// qSS On
				setIsQssEnabled(true)
				await setIsUseQss('true')
			}
			else {
				// qSS Off
				setIsQssEnabled(false)
				await setIsUseQss('false')
			}
		} catch (e) {
			console.error(e);
		}
	}

	// const handleShare = useCallback(() => {
	// 	const message = `${i18next.t('see_more_screen_message_10')}\n\nAndroid: ${ANDROID_PLAY_STORE_URL}\n\niOS: ${APPLE_APP_STORE_URL}`
	// 	Share.share({
	// 		message: message,
	// 		title: i18next.t('see_more_screen_message_11')
	// 	})
	// }, [])

	const handleShare = useCallback(() => {
		const envShareUrl = setupContext.commonInfo?.telegram_miniapp_url || '';
		
		if(null != envShareUrl && '' !== envShareUrl) {
			const shareText = encodeURIComponent(i18next.t('see_more_screen_message_10'));
			const shareUrl = encodeURIComponent(envShareUrl);
			const url = `https://t.me/share/url?text=${shareText}&url=${shareUrl}`;
			console.log(`handleShare WebApp.openTelegramLink : ${url}`)
	
			try {
				WebApp.openTelegramLink(url);
			} catch (error) {
				console.log(`Error openTelegramLink`, error)
			}
		}
	}, [])

	const handleResetTxHistory = useCallback(async () => {
		try {
				const walletAddress = await getWalletAddress()
				const network = await getBlockChain()
				const tid = await getTelegramId()
				
				// 진행중인 DB TX 현행화 중단
				stopRequestTxData(true)

				const isConfirm = await tgShowConfirm(i18next.t('see_more_screen_message_25'));
				if(true === isConfirm) {
					const result = await resetServerTxHistory(walletAddress, network, tid)
					if(true === result) {
						// DB TX 현행화 타이머 종료
						await stopDbSyncTimer()

						// DB TX 현행화 타이머 시작 
						// await startDbSyncTimer()

						await tgShowAlert(i18next.t('see_more_screen_message_23'));
					}
				else {
					await tgShowAlert(i18next.t('see_more_screen_message_24'));
				}
			}
		} catch (error) {
			console.log(`Error openTelegramLink`, error)
		}
	}, [])

	const handleToggleTheme = useCallback( async () => {
		await toggleTheme()

		const value = await localStorage.getItem('theme')
		if (value !== 'dark') {
			setIsDarkMode(false)
		} else {
			setIsDarkMode(true)
		}
	}, [toggleTheme])

	const styles = {
		container: {
			padding: "60px 5px 12px",
		} as React.CSSProperties,
		sectionTitleTop: {
			fontSize: 14,
			color: theme.text_15,
			width: "100%",
			paddingTop: "10px",
			paddingBottom: "10px",
			paddingLeft: "10px",
			paddingRight: "24px",
			boxSizing: "border-box"
		} as React.CSSProperties,
		sectionTitle: {
			fontSize: 14,
			color: theme.text_15,
			width: "100%",
			paddingTop: "20px",
			paddingBottom: "10px",
			paddingLeft: "10px",
			paddingRight: "24px",
			boxSizing: "border-box"
		} as React.CSSProperties,
		item: {
			display: "flex",
			alignItems: 'center',
			justifyContent: "space-between",
			padding: "19px",
			paddingLeft: " 10px",
			borderBottom: `1px solid ${theme.border_04}`,
			cursor: "pointer"
		} as React.CSSProperties,
		icon: {
			width: 24,
			height: 24,
			marginRight: 8
		} as React.CSSProperties,
		itemText: {
			fontSize: 18,
			color: theme.text_15,
		} as React.CSSProperties,
		versionNumber: {
			fontSize: 16,
			color: theme.text_03
		} as React.CSSProperties,
		arrowIcon: {
			width: 13,
			height: 21,
			tintColor: theme.text_03
		} as React.CSSProperties,
		groupContainer: {
			borderRadius: 10,
			marginVertical: 8,
			overflow: 'hidden',
			width: "100%",
			padding: "0 15px",
			boxSizing: "border-box",
		} as React.CSSProperties,
		topRounded: {
			borderTopLeftRadius: 10,
			borderTopRightRadius: 10
		} as React.CSSProperties,
		bottomRounded: {
			borderBottomLeftRadius: 10,
			borderBottomRightRadius: 10
		} as React.CSSProperties,
	}
	
	return (
		<div className='container' style={{ ...styles.container, backgroundColor: theme.background_normal }}>
			<div style={{ width: "100%" }}>
				<CustomText style={{ ...styles.sectionTitleTop, color: theme.text_05 }}>
					{t('see_more_screen_message_16')}
				</CustomText>
				<div style={{ ...styles.groupContainer, backgroundColor: theme.divider_background_02 }}>
					{items.slice(0, 2).map((item, index) => (
						<div
							key={index}
							style={{
								...styles.item,
								borderColor: theme.divider_background_03,
								backgroundColor: theme.divider_background_02,
								...(index === 0 ? styles.topRounded : {}),
								...(index === 2 ? styles.bottomRounded : {}),
							}}
							onClick={() => handleEnvItemPress(item.screen)}
							>
							<>
								<CustomText style={{ ...styles.itemText, color: theme.label_strong }}>{item.text}</CustomText>
								{item.screen === 'QssSettingMnemonicScreen' ? (
									<CustomText style={{ ...styles.versionNumber, color: theme.text_10 }}>
										{true === usingQssMnemonic ? (
											t('see_more_screen_message_19')
										) : (
											t('see_more_screen_message_20')
										)}
									</CustomText>
								) : (
									<img src="./img/icon_small_arrow_right.png" alt="arrow" style={styles.arrowIcon} />
								)}
							</>
						</div>
					))}
				</div>

				<CustomText style={{ ...styles.sectionTitle, color: theme.text_05 }}>
					{t('see_more_screen_message_01')}
				</CustomText>
				<div style={{ ...styles.groupContainer, backgroundColor: theme.divider_background_02 }}>
					{items.slice(2, 5).map((item, index) => (
						<div
							key={index}
							style={{
								...styles.item,
								borderColor: theme.divider_background_03,
								backgroundColor: theme.divider_background_02,
								...(index === 0 ? styles.topRounded : {}),
								...(index === 2 ? styles.bottomRounded : {}),
							}}
							// onClick={() => navigate(`/${item.screen}`)}
							onClick={() => !item.isToggle && handleItemPress(item.screen, item.hasBadge)}
						>
							<>
								<CustomText style={{ ...styles.itemText, color: theme.label_strong }}>{item.text}</CustomText>
								{item.isToggle && <CustomSwtich onToggle={handleToggleTheme} isOn={isDarkMode === true ? true : false} />}
								{!item.isToggle && (
									<img src="./img/icon_small_arrow_right.png" alt="arrow" style={styles.arrowIcon} />
								)}
							</>
						</div>
					))}
				</div>
				
				<CustomText style={{ ...styles.sectionTitle, color: theme.text_05 }}>
					{t('see_more_screen_message_21')}
				</CustomText>
				<div style={{ ...styles.groupContainer, backgroundColor: theme.divider_background_02 }}>
					{items.slice(5, 6).map((item, index) => (
						<div
							key={index}
							style={{
								...styles.item,
								borderColor: theme.divider_background_03,
								backgroundColor: theme.divider_background_02,
								...(index === 0 ? styles.topRounded : {}),
								...(index === items.length - 1 ? styles.bottomRounded : {}),
							}}
							onClick={() => handleItemPress(item.screen, item.hasBadge)}
						>
							<CustomText style={{ ...styles.itemText, color: theme.label_strong }}>{item.text}</CustomText>
							<img src="./img/icon_small_arrow_right.png" alt="arrow" style={styles.arrowIcon} />
						</div>
					))}
				</div>

				<CustomText style={{ ...styles.sectionTitle, color: theme.text_05 }}>
					{t('see_more_screen_message_08')}
				</CustomText>
				<div style={{ ...styles.groupContainer, backgroundColor: theme.divider_background_02 }}>
					{items.slice(6, 9).map((item, index) => (
						<div
							key={index}
							style={{
								...styles.item,
								borderColor: theme.divider_background_03,
								backgroundColor: theme.divider_background_02,
								...(index === 0 ? styles.topRounded : {}),
								...(index === items.length - 1 ? styles.bottomRounded : {}),
							}}
							onClick={() => handleItemPress(item.screen, item.hasBadge)}
						>
							<CustomText style={{ ...styles.itemText, color: theme.label_strong }}>
								{item.text+' '}
								{item.screen === 'VersionInfo' ? (
									<ExternalLink color={theme.text_01} style={{ marginBottom: -5 }} size={18} />
								) : item.screen === 'Terms' ? (
									<Link color={theme.text_01} style={{ marginBottom: -5 }} size={18} />
								) : item.screen === 'PrivacyPolicy' ? (
									<Link color={theme.text_01} style={{ marginBottom: -5 }}  size={18} />
								) : (
									<></>
								)}
							</CustomText>
							{item.screen === 'VersionInfo' ? (
								<>
								<CustomText style={{ ...styles.versionNumber, color: theme.text_10 }}>
									{item.version}
								</CustomText>
								</>
							) : (
								<img src="./img/icon_small_arrow_right.png" alt="arrow" style={styles.arrowIcon} />
							)}
						</div>
					))}
				</div>

				<CustomText style={{ ...styles.sectionTitle, color: theme.text_05 }}>
					{t('see_more_screen_message_15')}
				</CustomText>
				<div style={{ ...styles.groupContainer, backgroundColor: theme.divider_background_02 }}>
					{items.slice(9).map((item, index) => (
						<div
							key={index}
							style={{
								...styles.item,
								borderColor: theme.divider_background_03,
								backgroundColor: theme.divider_background_02,
								...(index === 0 ? styles.topRounded : {}),
								...(index === items.length - 1 ? styles.bottomRounded : {}),
							}}
							onClick={() => handleItemPress(item.screen, item.hasBadge)}
						>
							<CustomText style={{ ...styles.itemText, color: theme.label_strong }}>{item.text}</CustomText>
							{item.screen === 'VersionInfo' ? (
								<CustomText style={{ ...styles.versionNumber, color: theme.text_10 }}>
									{item.version}
								</CustomText>
							) : (
								<img src="./img/icon_small_arrow_right.png" alt="arrow" style={styles.arrowIcon} />
							)}
						</div>
					))}
				</div>




			</div>
		</div>
	)
}

export default SeeMoreScreen
